import { useState } from "react";

import { Button, Input } from "@newsela/angelou";
import PropTypes from "prop-types";

import globalToasterRef from "@/base/globalToasterRef";
import useLazyClassroomGetList from "@/classrooms/useLazyClassroomGetList";
import useStudentClassroomPost from "@/student/useStudentClassroomPost";
import useUser from "@/users/useUser";
import {
  EVENT_TOAST_FAILED_CLASS_ERROR,
  EVENT_TOAST_FAILED_CLASS_ARCHIVED,
  EVENT_TOAST_ERROR_JOIN_CLASS,
  EVENT_TOAST_SUCCESS_JOIN_CLASS,
} from "./JoinClass.utils";
import { containerCss, buttonCss, inputCss } from "./JoinClass.style";

const propTypes = {
  /**
   * Callback function that is called after the classroom is assigned to the student
   */
  onJoinedClass: PropTypes.func.isRequired,
};

const JoinClass = ({ onJoinedClass }) => {
  const { data: user } = useUser();
  const [searchClassroom] = useLazyClassroomGetList();
  const [addStudentClassroom] = useStudentClassroomPost();
  const [classCode, setClassCode] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    const { data: classroom, error: classroomError } = await searchClassroom({
      code: classCode,
    });
    if (classroomError) {
      globalToasterRef.current.displayToast(EVENT_TOAST_FAILED_CLASS_ERROR);
    } else if (classroom.date_archived) {
      globalToasterRef.current.displayToast(EVENT_TOAST_FAILED_CLASS_ARCHIVED);
    } else {
      const { error } = await addStudentClassroom({
        student_id: user.student.id,
        classroom_id: classroom.id,
      });
      if (error) {
        globalToasterRef.current.displayToast(EVENT_TOAST_ERROR_JOIN_CLASS);
      } else {
        setClassCode("");
        onJoinedClass(classroom);
        globalToasterRef.current.displayToast(EVENT_TOAST_SUCCESS_JOIN_CLASS);
      }
    }
    setIsSaving(false);
  };

  return (
    <form css={containerCss} aria-label="Join class">
      <Input
        label="Class code"
        inputType={Input.inputTypes.text}
        placeholder="Start typing..."
        value={classCode}
        onChange={(e) => setClassCode(e.target.value)}
        __cssFor={inputCss}
      />
      <Button
        flavor={Button.flavors.primary}
        __cssFor={buttonCss}
        disabled={!classCode || isSaving}
        type="submit"
        onClick={onSubmit}
      >
        Join class
      </Button>
    </form>
  );
};

JoinClass.propTypes = propTypes;

export default JoinClass;
